import React, {useEffect,useState} from 'react'
import axios from "axios";
import config from "../../../config.js";
import {useHistory, useParams} from "react-router-dom";
import {toast} from "react-toastify";
import {trans} from "../../utils";



const Index = (ComponentToRenderData) => {

    let history = useHistory();
    const params = useParams();
    const SystemUrl = ComponentToRenderData.SystemUrl;
    const token = localStorage.getItem('token')
    const [data, setData ] = useState([]);

    useEffect(() => {
        axios(config.SystemUrl + `Profile/0`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => {
                setData(oldData=>({...oldData,email:result.data.data.email}))
                setData(oldData=>({...oldData,allow_notification:result.data.data.allow_notification}))
                if(result.data.data.allow_notification == 1){
                    document.getElementById('allow_notification').checked = true;
                }
            });

    }, [])

    const handleSubmitChange = event => {
        event.preventDefault();
        axios.post(config.SystemUrl + `Profile`,data)
            .then(result => {
                toast.success('Success');
            })
            .catch(async (error) => {
                if (error.response.status == 422) {
                    alert(Object.values(error.response.data.errors)[0])
                }else{
                    alert(error.response.data.message);
                }
            });
    };

    const handleAllowNotification = (e) =>{
        if(e.target.checked){
            setData(oldData=>({...oldData,allow_notification:1}))
        }else {
            setData(oldData=>({...oldData,allow_notification:0}))
        }
    }

    const handleEmailChange = event => {
        setData({ ...data, email: event.target.value });
    };

    const handlePasswordChange = event => {
        setData({ ...data, password: event.target.value });
    };

    return (
        <>
            <div className="card mb-5 mb-xl-8">
                <div className="card-body pt-3">
                    <form onSubmit={handleSubmitChange}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="message-text"
                                           className="col-form-label">{trans('Email')} :</label>
                                    <input
                                        className="form-control"
                                        type="email" name="email"
                                        onChange={handleEmailChange} autoFocus
                                        value={data && data.email}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="message-text"
                                           className="col-form-label">{trans('Password')} :</label>
                                    <input
                                        className="form-control"
                                        type="password" name="password"
                                        onChange={handlePasswordChange} autoFocus
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox"
                                           onChange={handleAllowNotification} id="allow_notification" />
                                        <label className="form-check-label mt-2" htmlFor="flexCheckDefault">
                                            {trans('Allow Notifications')}
                                        </label>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <button type="submit" className="btn btn btn-light-primary waves-effect waves-light">
                                {trans('Submit')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
export default Index;
